export default __webpack_public_path__ + "static/media/clientes3.a3310e2b.png";